export const MOBILE_BOTTOM_BAR_ROUTES = [
  '/multibanking-platform',
  '/profile/portfolio',
  '/favourites',
];
